import type { RouteSeo } from './seoData';
import { getSiteUrl } from './seoData';

function setMetaTag(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

interface HeadSnapshot {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  twitterTitle: string;
  twitterDescription: string;
}

let snapshot: HeadSnapshot | null = null;

function captureSnapshot(): HeadSnapshot {
  if (snapshot) return snapshot;
  const getMeta = (selector: string): string =>
    document.head.querySelector<HTMLMetaElement>(selector)?.getAttribute('content') || '';
  snapshot = {
    title: document.title,
    description: getMeta('meta[name="description"]'),
    keywords: getMeta('meta[name="keywords"]'),
    canonical: document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.getAttribute('href') || '',
    ogTitle: getMeta('meta[property="og:title"]'),
    ogDescription: getMeta('meta[property="og:description"]'),
    ogUrl: getMeta('meta[property="og:url"]'),
    twitterTitle: getMeta('meta[name="twitter:title"]'),
    twitterDescription: getMeta('meta[name="twitter:description"]'),
  };
  return snapshot;
}

export function applyHomeMeta(): void {
  const s = captureSnapshot();
  document.title = s.title;
  setMetaTag('name', 'description', s.description);
  setMetaTag('name', 'keywords', s.keywords);
  setCanonical(s.canonical);
  setMetaTag('property', 'og:title', s.ogTitle);
  setMetaTag('property', 'og:description', s.ogDescription);
  setMetaTag('property', 'og:url', s.ogUrl);
  setMetaTag('name', 'twitter:title', s.twitterTitle);
  setMetaTag('name', 'twitter:description', s.twitterDescription);
}

export function applyRouteMeta(seo: RouteSeo): void {
  const siteUrl = getSiteUrl();
  const canonical = `${siteUrl}${seo.path}`;
  document.title = seo.title;
  setMetaTag('name', 'description', seo.description);
  setMetaTag('name', 'keywords', seo.keywords);
  setCanonical(canonical);
  setMetaTag('property', 'og:title', seo.title);
  setMetaTag('property', 'og:description', seo.description);
  setMetaTag('property', 'og:url', canonical);
  setMetaTag('name', 'twitter:title', seo.title);
  setMetaTag('name', 'twitter:description', seo.description);
}